/**
 * «Sin permiso» — lo que se ve cuando la API devuelve `403` (RN-ROL-02).
 *
 * El detalle que importa: **el intento ya quedó auditado del lado del backend** como
 * consulta sensible denegada (AF §11, caso borde del Coordinador intersedes). Decírselo a
 * la persona es parte del control interno, no una amenaza.
 */
import { Link } from "react-router";
import { ShieldX } from "lucide-react";
import { Button } from "../../components/ui/Button.js";
import { useAuth } from "../../lib/auth/index.js";
import { ROLE_LABEL } from "../../lib/labels.js";
import { landingFor } from "../nav.js";

export function Forbidden({ what }: { what?: string }) {
  const { user } = useAuth();

  return (
    <div className="relative isolate flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <ShieldX aria-hidden className="size-7 text-warning" />
      <h1 className="font-display text-[24px] font-semibold tracking-tight">Sin permiso</h1>
      <p className="max-w-[56ch] text-[13px] leading-relaxed text-dim">
        {what ?? "Esta pantalla"} no está entre lo que puede ver tu rol
        {user ? ` (${ROLE_LABEL[user.role]})` : ""}. Los permisos se controlan en cada operación, no
        sólo en el menú, y por eso este intento quedó registrado en la auditoría. Si necesitás
        entrar acá, pedíselo a Administración.
      </p>
      <Link to={user ? landingFor(user.role) : "/login"}>
        <Button variant="primary">Volver a mi inicio</Button>
      </Link>
    </div>
  );
}

export default Forbidden;
